import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as XLSX from 'xlsx';

interface ReceiptLedgerDialogData {
  val: any[];
  filters: any;
}

@Component({
  selector: 'app-subscriber-rec-ledger-address-label',
  // standalone: true,
  // imports: [],
  templateUrl: './subscriber-rec-ledger-address-label.component.html',
  styleUrl: './subscriber-rec-ledger-address-label.component.scss'
})
export class SubscriberRecLedgerAddressLabelComponent implements OnInit {

data = [];
   dataSource: any[] = [];
  selectedFilters: any = {};

    constructor(
      private dialogref: MatDialogRef<SubscriberRecLedgerAddressLabelComponent>,
      @Inject(MAT_DIALOG_DATA) public res: ReceiptLedgerDialogData
    ) {}


  ngOnInit(): void {
      // this.data = this.res['val'];
      // console.log(this.data);
  
      //Receipt Number Show In Ascending Order
  //   this.data = this.res['val'].sort((a, b) => {
  //   const getLastNumber = (rcpt: string) => {
  //     const parts = rcpt?.split('/');
  //     return parts && parts.length ? Number(parts[parts.length - 1]) : 0;
  //   };
  
  //   return getLastNumber(a.rcpt_no) - getLastNumber(b.rcpt_no);
  // });

   this.dataSource = this.res.val.sort((a, b) => {
      const getLastNumber = (rcpt: string) => {
        const parts = rcpt?.split('/');
        return parts && parts.length ? Number(parts[parts.length - 1]) : 0;
      };
      return getLastNumber(a.rcpt_no) - getLastNumber(b.rcpt_no);
    });
  
  // filters 
    this.selectedFilters = this.res.filters || {}; 
   
    }
  
  //    ngOnInit(): void {
  //   // sort केलेलं data
  //   this.dataSource = this.res.val.sort((a, b) => {
  //     const getLastNumber = (rcpt: string) => {
  //       const parts = rcpt?.split('/');
  //       return parts && parts.length ? Number(parts[parts.length - 1]) : 0;
  //     };
  //     return getLastNumber(a.rcpt_no) - getLastNumber(b.rcpt_no);
  //   });

  //   // filters मिळाले
  //   this.selectedFilters = this.res.filters || {};
  // }


 getSubTypeShort(type: string): string {
  if (!type) return '';

  switch (type.trim()) {
    case 'वार्षिक':
      return 'वा';
    case 'त्रैवार्षिक':
      return 'त्रै';
    case 'पंचवार्षिक':
      return 'पंच';
    case 'अनामत':
      return 'अ';
    case 'सप्रेम भेट-जाहिरात प्रतिनीधी':
      return 'स.भे.जा.प्र';
    case 'लोकनेता ग्रंथयात्री वार्षिक':
      return 'लो.ग्रं.वा';
    case 'सप्रेम भेट - संपादकीय विभाग':
      return 'स.भे-सं.वि';
    case 'मुदत ठेव (पंचवार्षिक वर्गणीदार)':
      return 'मु.ठे';
    case 'आजीव':
      return 'आ';
    case 'रामसेवक ग्रंथयात्री':
      return 'रा.ग्रं';
    case 'रा.स्व.ग्रंथ':
      return 'रा.स्व.ग्रं';
    case 'देणगी':
      return 'दे';
    case 'लो.टिळक ग्रंथयात्री':
      return 'लो.टि.ग्रं';
    case 'हिंदुत्व':
      return 'हिं';
    case 'परप्रांत वा':
      return 'प.वा';
    case 'राष्ट्रोत्थान 2100':
      return 'राष्ट्रो 2100';
    case 'राष्ट्रोत्थान 2500':
      return 'राष्ट्रो 2500';
    case 'रा.स्व. संघ ग्रंथ':
      return 'रा.स्व.सं.ग्रं';
    case 'हितचिंतक सप्रेम भेट':
      return 'हि.स.भे';
    case 'सप्रेम भेट-संघ परिवार':
      return 'स.भे-सं.प';
    case 'सप्रेम भेट-वर्गणीदार प्रतिनीधी':
      return 'स.भे-व.प्र';
    case 'हिंदुत्व- 2':
      return 'हिं- 2';
    case 'ऑनलाईन अंक वार्षिक':
      return 'ऑनलाईन अंक वार्षिक';
    case 'ऑनलाईन अंक सहामाही':
      return 'ऑन.अं.स';
    case 'विश्वसंचार संघाचा 2100':
      return 'विश्व.सं 2100';
    case 'विश्वसंचार संघाचा 2500':
      return 'विश्व.सं 2500';
    default:
      return type; // जर काही match नाही झाला तर full name दाखवा
  }
}

   
  
  
    exportExcel(fileName): void {
      /* table id is passed over here */
      let element = document.getElementById('print-section');
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
      /* save to file */
      XLSX.writeFile(wb, fileName + '.xlsx');
    }
  

}
